import React from 'react'
import Navbar from './Navbar';
function Notfound() {
  return (
    <>
 
    <div className='notfound'>Page Not Found</div>
    </>
  )
}

export default Notfound